import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const GOOGLE_ADS_TAG_ID = "AW-1817186425";
const THANK_YOU_PATH = "/thank-you";
// const CONTACT_CONVERSION_LABEL = "F4AVCLKD5LccEPnNgtID";
const CONTACT_CONVERSION_LABEL = "F4AVCLKD5LccEPnNtID";
const SESSION_STORAGE_KEY = "google_ads_conversion_sent";

function getPagePath(location) {
  return `${location.pathname}${location.search}`;
}

function sendPageView(location) {
  if (typeof window.gtag !== "function") return;

  window.gtag("config", GOOGLE_ADS_TAG_ID, {
    page_location: window.location.href,
    page_path: getPagePath(location),
  });
}

function sendContactConversion() {
  if (typeof window.gtag !== "function" || !CONTACT_CONVERSION_LABEL) return;

  window.gtag("event", "conversion", {
    send_to: `${GOOGLE_ADS_TAG_ID}/${CONTACT_CONVERSION_LABEL}`,
  });
}

export default function GoogleAdsTracking() {
  const location = useLocation();
  const isInitialLoadRef = useRef(true);

  useEffect(() => {
    if (isInitialLoadRef.current) {
      isInitialLoadRef.current = false;
    } else {
      sendPageView(location);
    }

    if (location.pathname === THANK_YOU_PATH) {
      const conversionSent = sessionStorage.getItem(SESSION_STORAGE_KEY);
      if (!conversionSent) {
        sessionStorage.setItem(SESSION_STORAGE_KEY, "true");
        sendContactConversion();
      }
    } else {
      sessionStorage.removeItem(SESSION_STORAGE_KEY);
    }
  }, [location]);

  return null;
}
